export default window //if it isn't window, we'll be stubbing this module anyway
